// extracted by mini-css-extract-plugin
export var button = "_dk-0";
export var icon = "_dk-1";